import React from 'react';
import List from './List';

const Leads = () => (
  <div style={{ marginTop: 20 }}>
    <List />
  </div>
);

export default Leads;
